/**
 * Custom-Mindmap public API — the only import path for app code (`from 'Custom-Mindmap'`).
 * Every export is described in the migration docs, 04-api-spec.md.
 */
import { CustomMindmap } from './components';

export { CustomMindmap, Handle } from './components';
export type { CustomMindmapProps, HandleProps } from './components';
export {
  addEdge,
  applyGraphDiff,
  applyEdgeChanges,
  applyNodeChanges,
  ConnectionMode,
  copyElements,
  darkenColor,
  diffGraph,
  EMPTY_HISTORY,
  getBezierPath,
  getContentOrigin,
  getRectOfNodes,
  getShapePath,
  getSmoothStepPath,
  getTransformForBounds,
  isEmptyGraphDiff,
  isShapeType,
  MarkerType,
  pasteElements,
  Position,
  pushHistory,
  redoHistory,
  undoHistory,
} from './core';
export type {
  ClipboardContent,
  Connection,
  DefaultEdgeOptions,
  Edge,
  EdgeChange,
  EdgeMarker,
  EdgeMarkerType,
  GraphDiff,
  GraphSnapshot,
  History,
  HistoryStep,
  Node,
  NodeChange,
  NodeProps,
  PasteOptions,
  Rect,
  ShapeType,
  Viewport,
  XYPosition,
} from './core';
export { useCustomMindmap, useEdgesState, useNodesState } from './hooks';
export type { CustomMindmapInstance } from './hooks';
export { Background, ControlButton, Controls, MiniMap, NodeResizer, NodeToolbar, Shape } from './plugins';
export type {
  BackgroundProps,
  ControlButtonProps,
  ControlsProps,
  MiniMapProps,
  NodeResizerProps,
  NodeToolbarProps,
  ShapeProps,
} from './plugins';
export { CustomMindmapProvider } from './store';
export type { NodeTypes } from './store';

export default CustomMindmap;
